import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "showInfoIcon"],
  _excluded2 = ["option", "children", "inboxId", "isOptionItemInDropdown", "isNewSeatingModel"];
import { InfoIcon } from 'foundations-assets';
import get from 'transmute/get';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { checkIsUserOption } from '../../routing-rules/utils/checkIsUserOption';
import FreeUserDowngradedTooltip from '../../routing-rules/components/tooltips/FreeUserDowngradedTooltip';
import RemovedFromInboxUserTooltip from '../../routing-rules/components/tooltips/RemovedFromInboxUserTooltip';
import RemovedFromPortalUserTooltip from '../../routing-rules/components/tooltips/RemovedFromPortalUserTooltip';
import TeamContainsFreeUsersTooltip from './tooltips/TeamContainsFreeUsersTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AgentItemContainer = _ref => {
  let {
      children,
      showInfoIcon = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      children: [children, showInfoIcon && /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "400",
        children: /*#__PURE__*/_jsx(InfoIcon, {})
      })]
    })
  }));
};
AgentItemContainer.displayName = 'AgentSelectItemContainer';
const AgentSelectItem = props => {
  const {
      option,
      children,
      inboxId,
      isOptionItemInDropdown = false,
      isNewSeatingModel = false
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded2);
  const containerProps = Object.assign({}, otherProps, {
    children
  });

  // this is used to render an option in the dropdown list
  if (isOptionItemInDropdown) {
    const isHiddenUser = get('hidden', option);
    const containsFreeUsers = get('containsFreeUsers', option);
    const isRoutableUser = get('routable', option);
    if (isHiddenUser || isNewSeatingModel && checkIsUserOption(option) && !isRoutableUser) {
      return null;
    }
    if (containsFreeUsers) {
      return /*#__PURE__*/_jsx(TeamContainsFreeUsersTooltip, {
        isNewSeatingModel: isNewSeatingModel,
        children: /*#__PURE__*/_jsx(AgentItemContainer, Object.assign({}, containerProps, {
          showInfoIcon: true
        }))
      });
    }

    // regular assignable users or teams, don't show a tooltip
    return /*#__PURE__*/_jsx(AgentItemContainer, Object.assign({}, containerProps));
  }

  // this option is a user
  if (checkIsUserOption(option)) {
    if (!get('userInPortal', option)) {
      return /*#__PURE__*/_jsx(RemovedFromPortalUserTooltip, {
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: children
        })
      });
    }
    if (!get('canViewInbox', option)) {
      return /*#__PURE__*/_jsx(RemovedFromInboxUserTooltip, {
        inboxId: inboxId || '',
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: children
        })
      });
    }
    if (!get('routable', option)) {
      return /*#__PURE__*/_jsx(FreeUserDowngradedTooltip, {
        isNewSeatingModel: isNewSeatingModel,
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: children
        })
      });
    }
  }

  // this option is a team or a regular assignable user, don't show a tooltip
  return /*#__PURE__*/_jsx(AgentItemContainer, Object.assign({}, containerProps));
};
AgentSelectItem.displayName = 'AgentSelectItem';
export default AgentSelectItem;